import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const BASE = `${ADMIN_API_BASE}/places`;
const _err = (e) => { if (e.response) console.error('Admin places error:', e.response.status, e.response.data); };
const multipartAuth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const placesError = (e, fb = 'Не удалось выполнить операцию') => e?.response?.data?.error || fb;

// -------- Города --------
export const APIAdminCities = async (token, params = {}) => {
    try { const r = await axios.get(`${BASE}/cities/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminCityCreate = async (token, data) => {
    try { const r = await axios.post(`${BASE}/cities/create/`, data, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminCityUpdate = async (token, id, data) => {
    try { const r = await axios.patch(`${BASE}/cities/${id}/update/`, data, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminCityDelete = async (token, id) => {
    try { const r = await axios.delete(`${BASE}/cities/${id}/delete/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

// -------- Категории --------
export const APIAdminPlaceCategories = async (token, params = {}) => {
    try { const r = await axios.get(`${BASE}/categories/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPlaceCategoryCreate = async (token, data) => {
    try { const r = await axios.post(`${BASE}/categories/create/`, data, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPlaceCategoryUpdate = async (token, id, data) => {
    try { const r = await axios.patch(`${BASE}/categories/${id}/update/`, data, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPlaceCategoryDelete = async (token, id) => {
    try { const r = await axios.delete(`${BASE}/categories/${id}/delete/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

// -------- Точки --------
export const APIAdminPlaces = async (token, params = {}) => {
    try { const r = await axios.get(`${BASE}/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPlaceDetail = async (token, id) => {
    try { const r = await axios.get(`${BASE}/${id}/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPlaceCreate = async (token, formData) => {
    try { const r = await axios.post(`${BASE}/create/`, formData, multipartAuth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPlaceUpdate = async (token, id, formData) => {
    try { const r = await axios.post(`${BASE}/${id}/update/`, formData, multipartAuth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPlaceDelete = async (token, id) => {
    try { const r = await axios.delete(`${BASE}/${id}/delete/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};